import { Box, Table, Text } from '@factorialco/deprecated-design-system'

interface SummaryDescriptionCellProps {
  description: string
}

export const SummaryDescriptionCell = ({ description }: SummaryDescriptionCellProps) => (
  <Table.Cell noBorder paddingX="s4" paddingY="s2">
    <Box height="s40" flexDirection="column" justifyContent="center">
      <Text.Normal ellipsis size="200">
        {description}
      </Text.Normal>
    </Box>
  </Table.Cell>
)
